/**
 * @name integration
 * @autor Jaime.salazar@u-planner.com
 */
 
    class tablesServices {

     constructor($resource,SERVICE_URL_CONSTANT){
  
         var catalogues = $resource(SERVICE_URL_CONSTANT.tablesFiltering +'/:controller',{},{

          getCatalogueCampus :{
               method:'GET',
               params : {
                controller: 'cataloguecampuses'
               }
             },

          getCatalogueCarreras :{
               method:'GET',
               params : {
                controller: 'cataloguecareers'
               }
             },

             getCatalogueUnidadAcademica :{
               method:'GET',
               params : {
                controller: 'catalogueunits'
               }
             }

         });

         var services = $resource(SERVICE_URL_CONSTANT.tablesFiltering  +'/:controller',{},{
             getActivity :{
               method:'GET',
               params : {
                controller: 'activities'
               }
             },
             getCampus :{
               method:'GET',
               params : {
                controller: 'campuses'
               }
             },
             getInstitution :{
               method:'GET',
               params : {
                controller: 'institutions'
               }
             },
             getJornada :{
               method:'GET',
               params : {
                controller: 'shifts'
               }
             },
             getCarrera :{
               method:'GET',
               params : {
                controller: 'careers'
               }

             },
             getUnidadAcademica : {
                method: 'GET',
                params : {
                    controller: 'academicunit'
                }
            },
             getPeriod :{
               method:'GET',
               params : {
                controller: 'period'
               }
             },
            getPlanMateria : {
                method: 'GET',
                params : {
                    controller: 'coursepensum'
                }
            },
             getTipoUso : {
                method: 'GET',
                params : {
                    controller: 'usagetype'
                }
            },
            getRecursoTipoUso : {
                method: 'GET',
                params : {
                    controller: 'classroomusagetype'
                }
            },
            getRecurso:{
              method:'GET',
              params : {
               controller: 'classroom'
              }
            },
            getUnidadAcademicaMateria : {
                method: 'GET',
                params : {
                    controller: 'academicunitcourse'
                }
            },
            getCPJCarrera :{
              method:'GET',
              params : {
               controller: 'campusperiodshiftcareer'
              }
            },
            getMateriaActivity : {
                method: 'GET',
                params : {
                    controller: 'courseactivity'
                }
            },
            getMateriaActivityUse : {
                method: 'GET',
                params : {
                    controller: 'courseactivityusagetype'
                }
            },
            
             getTable :{
               method:'GET',
               params : {
                controller: 'careerspensum'
               }
             },
             
             getModulo :{
               method:'GET',
               params : {
                controller: 'modulesshift'
               }
             },

             getDocente :{
               method:'GET',
               params : {
                controller: 'teacher'
               }
             },
             getAsignacionDocente :{
               method:'GET',
               params : {
                controller: 'docente_materia_actividad.php'
               }
             },
            getNotaClase : {
                method: 'GET',
                params : {
                    controller: 'nota'
                }
            }

         });

		 var updates =$resource(SERVICE_URL_CONSTANT.tablesFiltering +'/:controller',{},{

             save :{
               method:'POST',
               params : {
                controller: 'save'
               }
		 }});

          return {
             services:services,
             catalogues :catalogues,
             updates :updates
         }

    }
}

tablesServices.$inject = ['$resource','SERVICE_URL_CONSTANT']

  export default angular.module('services.tablesServices', [])
  .service('tablesServices', tablesServices)
  .name;


// WEBPACK FOOTER //
// ./src/app/integration-front/tables/tablesServices.js